<ax-property-edit [form]="form" [autofocus]="false" [hint]="hint"></ax-property-edit>
<div class="h-button-wrapper">
  <button axButton filled color="primary" [disabled]="!form.valid" (click)="sendEmail()">
    {{ 'label.send' | translate }}
  </button>
</div>
